/**
 * Enum used to define the different modes for NodeParticleEditor
 */
export enum NodeParticleModes {
    /** Standard particle system */
    Particle = 0,
    /** SPS (Solid Particle System) */
    SolidParticle = 1,
}
